module.exports = __webpack_public_path__ + "img/slide-4-understand-how-to-2.121f9b24.png";